import { IconButton, Menu, MenuContent, MenuTrigger, MenuItem } from '@cad-arc';
import { useFullscreenModalControls } from '../../../modals/context/modal-context-provider';

export const BoloPanelKebabMenu = ({ boloId }: { boloId?: number }) => {
    const controls = useFullscreenModalControls();

    if (!boloId) {
        return null;
    }

    return (
        <Menu>
            <MenuTrigger asChild>
                <IconButton variant="ghost" icon="MoreActions" aria-label="More BOLO Action" />
            </MenuTrigger>
            <MenuContent>
                <MenuItem
                    onSelect={() =>
                        controls.open({
                            type: 'ASSOCIATE_BOLO',
                            props: { boloId, entityType: 'BOLO' },
                        })
                    }
                >
                    Associate BOLO
                </MenuItem>
                <MenuItem
                    onSelect={() =>
                        controls.open({
                            type: 'ASSOCIATE_BOLO',
                            props: { boloId, entityType: 'EVENT' },
                        })
                    }
                >
                    Associate Event
                </MenuItem>
            </MenuContent>
        </Menu>
    );
};
